// Alla lokala nycklar byggs här. Ingen annan kod får skriva egna nycklar,
// annars kan två projekt i samma webbläsare skriva över varandra.

export const LOCAL_PREFIX = "bams.draft";
export const QUEUE_PREFIX = "bams.queue";

export interface DraftScope {
  /** Dokumenttyp, t.ex. "skr" eller "risk-byggskede". */
  kind: string;
  /** Projekt (uppdrag) som dokumentet tillhör. */
  projectId?: string | null;
  /** Mapp inom projektet, om dokumentet ligger i en. */
  folderId?: string | null;
  /** Dokumentets id när det finns flera av samma typ. */
  documentId?: string | null;
}

const part = (value?: string | null) => (value && value.trim() ? value.trim() : "-");

/** Unik, projektskopad nyckel för ett utkast. */
export const draftKey = (scope: DraftScope): string =>
  [LOCAL_PREFIX, part(scope.kind), part(scope.projectId), part(scope.folderId), part(scope.documentId)].join(":");

/** Kön för sparningar som väntar på nätverk, skopad på samma sätt. */
export const queueKey = (scope: DraftScope): string => draftKey(scope).replace(LOCAL_PREFIX, QUEUE_PREFIX);

/** Sant för nycklar som tillhör lagringslagret. */
export const isManagedKey = (key: string): boolean =>
  key.startsWith(`${LOCAL_PREFIX}:`) || key.startsWith(`${QUEUE_PREFIX}:`);
